export const IconPack = {
  profile: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 10H16M8 14H16M8 18H12M8 4C8 5.10457 8.89543 6 10 6H14C15.1046 6 16 5.10457 16 4M8 4C8 2.89543 8.89543 2 10 2H14C15.1046 2 16 2.89543 16 4M8 4H7C4.79086 4 3 5.79086 3 8V18C3 20.2091 4.79086 22 7 22H17C19.2091 22 21 20.2091 21 18V8C21 5.79086 19.2091 4 17 4H16"
        stroke="#28303F"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  compare: (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 21.3253H16M16 21.3253V17.3253M16 21.3253L21 16.3253M6.5 9.82932L3 7.82932M3 7.82932L5 4.32532M3 7.82932L9.83 5.95932M4 16.3253L8 15.3253M8 15.3253L9 19.3253M8 15.3253L4.5 21.3253M21 5.32532L20.5 9.32532M20.5 9.32532L16.5 8.82532M20.5 9.32532L16 3.82532"
        stroke="#354052"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  rank: (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 19.3252V13.3252C9 13.06 8.89464 12.8056 8.70711 12.6181C8.51957 12.4306 8.26522 12.3252 8 12.3252H4C3.73478 12.3252 3.48043 12.4306 3.29289 12.6181C3.10536 12.8056 3 13.06 3 13.3252V19.3252C3 19.5904 3.10536 19.8448 3.29289 20.0323C3.48043 20.2198 3.73478 20.3252 4 20.3252M9 19.3252C9 19.5904 8.89464 19.8448 8.70711 20.0323C8.51957 20.2198 8.26522 20.3252 8 20.3252H4M9 19.3252C9 19.5904 9.10536 19.8448 9.29289 20.0323C9.48043 20.2198 9.73478 20.3252 10 20.3252H14C14.2652 20.3252 14.5196 20.2198 14.7071 20.0323C14.8946 19.8448 15 19.5904 15 19.3252M9 19.3252V9.3252C9 9.05998 9.10536 8.80563 9.29289 8.61809C9.48043 8.43055 9.73478 8.3252 10 8.3252H14C14.2652 8.3252 14.5196 8.43055 14.7071 8.61809C14.8946 8.80563 15 9.05998 15 9.3252V19.3252M4 20.3252H18M15 19.3252C15 19.5904 15.1054 19.8448 15.2929 20.0323C15.4804 20.2198 15.7348 20.3252 16 20.3252H20C20.2652 20.3252 20.5196 20.2198 20.7071 20.0323C20.8946 19.8448 21 19.5904 21 19.3252V5.3252C21 5.05998 20.8946 4.80563 20.7071 4.61809C20.5196 4.43055 20.2652 4.3252 20 4.3252H16C15.7348 4.3252 15.4804 4.43055 15.2929 4.61809C15.1054 4.80563 15 5.05998 15 5.3252V19.3252Z"
        stroke="#354052"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  institution: (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 21.3253H21M3 10.3253H21M5 6.32532L12 3.32532L19 6.32532M4 10.3253V21.3253M20 10.3253V21.3253M8 14.3253V17.3253M12 14.3253V17.3253M16 14.3253V17.3253"
        stroke="#354052"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  faculty: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 5V10.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M16.75 7V6.25H15.25V7H16.75ZM8.75 7V6.25H7.25V7H8.75ZM12 2L12.2633 1.29775C12.0936 1.23408 11.9064 1.23408 11.7367 1.29775L12 2ZM4 5L3.73666 4.29775C3.44393 4.40753 3.25 4.68737 3.25 5C3.25 5.31263 3.44393 5.59247 3.73666 5.70225L4 5ZM12 8L11.7367 8.70225C11.9064 8.76592 12.0936 8.76592 12.2633 8.70225L12 8ZM20 5L20.2633 5.70225C20.5561 5.59247 20.75 5.31263 20.75 5C20.75 4.68737 20.5561 4.40753 20.2633 4.29775L20 5ZM12.711 17.0059L12.1778 16.4785V16.4785L12.711 17.0059ZM14.2996 15.3996L14.8328 15.927L14.8328 15.927L14.2996 15.3996ZM15.238 15.1441L15.4496 14.4246L15.238 15.1441ZM9.70045 15.3996L10.2337 14.8722L9.70045 15.3996ZM11.289 17.0059L11.8222 16.4785L11.289 17.0059ZM8.762 15.1441L8.5504 14.4246L8.762 15.1441ZM19.25 22C19.25 22.4142 19.5858 22.75 20 22.75C20.4142 22.75 20.75 22.4142 20.75 22H19.25ZM3.25 22C3.25 22.4142 3.58579 22.75 4 22.75C4.41421 22.75 4.75 22.4142 4.75 22H3.25ZM15.25 7V9H16.75V7H15.25ZM8.75 9V7H7.25V9H8.75ZM12 12.25C10.2051 12.25 8.75 10.7949 8.75 9H7.25C7.25 11.6234 9.37665 13.75 12 13.75V12.25ZM15.25 9C15.25 10.7949 13.7949 12.25 12 12.25V13.75C14.6234 13.75 16.75 11.6234 16.75 9H15.25ZM11.7367 1.29775L3.73666 4.29775L4.26334 5.70225L12.2633 2.70225L11.7367 1.29775ZM12.2633 8.70225L20.2633 5.70225L19.7367 4.29775L11.7367 7.29775L12.2633 8.70225ZM11.7367 2.70225L19.7367 5.70225L20.2633 4.29775L12.2633 1.29775L11.7367 2.70225ZM12.2633 7.29775L4.26334 4.29775L3.73666 5.70225L11.7367 8.70225L12.2633 7.29775ZM13.2443 17.5332L14.8328 15.927L13.7663 14.8722L12.1778 16.4785L13.2443 17.5332ZM15.0264 15.8637C17.6994 16.6497 19.25 18.3265 19.25 20H20.75C20.75 17.3393 18.3869 15.2884 15.4496 14.4246L15.0264 15.8637ZM9.16718 15.927L10.7557 17.5332L11.8222 16.4785L10.2337 14.8722L9.16718 15.927ZM4.75 20C4.75 18.3265 6.30063 16.6497 8.97359 15.8637L8.5504 14.4246C5.61309 15.2884 3.25 17.3393 3.25 20H4.75ZM19.25 20V22H20.75V20H19.25ZM3.25 20V22H4.75V20H3.25ZM10.2337 14.8722C9.81027 14.444 9.17106 14.2421 8.5504 14.4246L8.97359 15.8637C9.02255 15.8493 9.09983 15.8589 9.16718 15.927L10.2337 14.8722ZM14.8328 15.927C14.9002 15.8589 14.9774 15.8493 15.0264 15.8637L15.4496 14.4246C14.8289 14.2421 14.1897 14.444 13.7663 14.8722L14.8328 15.927ZM12.1778 16.4785C12.0799 16.5774 11.9201 16.5774 11.8222 16.4785L10.7557 17.5332C11.4407 18.2259 12.5593 18.2259 13.2443 17.5332L12.1778 16.4785Z"
        fill="black"
      />
    </svg>
  ),
  faculties: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.4383 11.8278V10.7842L16.6483 11.3283C17.1783 11.5667 17.7858 11.5627 18.3126 11.3175L19.5579 10.7378V11.8278C19.5579 12.9654 18.6357 13.8876 17.4981 13.8876C16.3605 13.8877 15.4383 12.9654 15.4383 11.8278Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M21.5217 9.41067L18.1002 7.89003C17.7073 7.71537 17.2587 7.71537 16.8657 7.89003L13.4443 9.41067C13.2437 9.49981 13.2437 9.78448 13.4443 9.87362L16.8657 11.3943C17.2587 11.5689 17.7073 11.5689 18.1002 11.3943L21.5217 9.87362C21.7223 9.78448 21.7223 9.49981 21.5217 9.41067Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4706 15.4524C15.5737 15.4161 15.6793 15.3825 15.7874 15.3518C15.9627 15.3019 16.1503 15.3555 16.2788 15.4812L17.1106 16.2949C17.3156 16.4954 17.6503 16.4954 17.8553 16.2949L18.6871 15.4812C18.8156 15.3555 19.0032 15.3019 19.1785 15.3518C20.6474 15.7697 21.6721 16.7139 21.6721 17.8118C21.6721 18.3714 21.2032 18.825 20.6248 18.825H16.6629"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="13.6445"
        y1="10.3921"
        x2="13.6445"
        y2="12.0584"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M5.49801 9.83825V8.20216L7.76994 9.04885C8.22042 9.21674 8.71631 9.21674 9.16679 9.04885L11.4387 8.20216V9.83825C11.4387 11.4787 10.1088 12.8086 8.46837 12.8086C6.82789 12.8086 5.49801 11.4787 5.49801 9.83825Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M14.3881 6.07451L9.37304 3.84557C8.79702 3.58956 8.1395 3.58956 7.56348 3.84557L2.54837 6.07451C2.25437 6.20517 2.25437 6.62243 2.54837 6.75309L7.56348 8.98203C8.1395 9.23804 8.79702 9.23804 9.37304 8.98203L14.3881 6.75309C14.6821 6.62243 14.6821 6.20517 14.3881 6.07451Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.70324 14.991L7.92251 16.1838C8.22293 16.4777 8.71358 16.4777 9.014 16.1838L10.2333 14.991C10.4216 14.8067 10.6966 14.7282 10.9536 14.8013C13.1067 15.4138 14.6086 16.7979 14.6086 18.4072C14.6086 19.2274 13.9214 19.8924 13.0735 19.8924H3.86297C3.01516 19.8924 2.32787 19.2274 2.32787 18.4072C2.32787 16.7979 3.82986 15.4138 5.98293 14.8013C6.23992 14.7282 6.51489 14.8067 6.70324 14.991Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="3.20068"
        y1="7.28125"
        x2="3.20068"
        y2="10.3051"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  group: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.4383 11.8278V10.7842L16.6483 11.3283C17.1783 11.5667 17.7858 11.5627 18.3126 11.3175L19.5579 10.7378V11.8278C19.5579 12.9654 18.6357 13.8876 17.4981 13.8876C16.3605 13.8877 15.4383 12.9654 15.4383 11.8278Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M21.5217 9.41067L18.1002 7.89003C17.7073 7.71537 17.2587 7.71537 16.8657 7.89003L13.4443 9.41067C13.2437 9.49981 13.2437 9.78448 13.4443 9.87362L16.8657 11.3943C17.2587 11.5689 17.7073 11.5689 18.1002 11.3943L21.5217 9.87362C21.7223 9.78448 21.7223 9.49981 21.5217 9.41067Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.4706 15.4524C15.5737 15.4161 15.6793 15.3825 15.7874 15.3518C15.9627 15.3019 16.1503 15.3555 16.2788 15.4812L17.1106 16.2949C17.3156 16.4954 17.6503 16.4954 17.8553 16.2949L18.6871 15.4812C18.8156 15.3555 19.0032 15.3019 19.1785 15.3518C20.6474 15.7697 21.6721 16.7139 21.6721 17.8118C21.6721 18.3714 21.2032 18.825 20.6248 18.825H16.6629"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <line
        x1="13.6445"
        y1="10.3921"
        x2="13.6445"
        y2="12.0584"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M5.49801 9.83825V8.20216L7.76994 9.04885C8.22042 9.21674 8.71631 9.21674 9.16679 9.04885L11.4387 8.20216V9.83825C11.4387 11.4787 10.1088 12.8086 8.46837 12.8086C6.82789 12.8086 5.49801 11.4787 5.49801 9.83825Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M14.3881 6.07451L9.37304 3.84557C8.79702 3.58956 8.1395 3.58956 7.56348 3.84557L2.54837 6.07451C2.25437 6.20517 2.25437 6.62243 2.54837 6.75309L7.56348 8.98203C8.1395 9.23804 8.79702 9.23804 9.37304 8.98203L14.3881 6.75309C14.6821 6.62243 14.6821 6.20517 14.3881 6.07451Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.70324 14.991L7.92251 16.1838C8.22293 16.4777 8.71358 16.4777 9.014 16.1838L10.2333 14.991C10.4216 14.8067 10.6966 14.7282 10.9536 14.8013C13.1067 15.4138 14.6086 16.7979 14.6086 18.4072C14.6086 19.2274 13.9214 19.8924 13.0735 19.8924H3.86297C3.01516 19.8924 2.32787 19.2274 2.32787 18.4072C2.32787 16.7979 3.82986 15.4138 5.98293 14.8013C6.23992 14.7282 6.51489 14.8067 6.70324 14.991Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <line
        x1="3.20068"
        y1="7.28125"
        x2="3.20068"
        y2="10.3051"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  saved_comparision: (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 17.3253H3M21 17.3253L18 20.3253M21 17.3253L18 14.3253M18 4.32532L21 7.32532M21 7.32532L18 10.3253M21 7.32532H3"
        stroke="#354052"
        strokeWidth="2"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  saved_ranking: (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 3.3252V21.3252H21M20 18.3252V21.3252M16 16.3252V21.3252M12 13.3252V21.3252M8 16.3252V21.3252M3 11.3252C9 11.3252 8 6.3252 12 6.3252C16 6.3252 15 11.3252 21 11.3252"
        stroke="#354052"
        strokeWidth="2"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  copy_link: (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 15.3255L15 9.3255M11 6.3255L11.463 5.7895C12.4008 4.85183 13.6727 4.3251 14.9989 4.3252C16.325 4.32529 17.5968 4.8522 18.5345 5.79C19.4722 6.72781 19.9989 7.99969 19.9988 9.32585C19.9987 10.652 19.4718 11.9238 18.534 12.8615L18 13.3255M13 18.3255L12.603 18.8595C11.6543 19.7977 10.3738 20.3239 9.03952 20.3239C7.70523 20.3239 6.42477 19.7977 5.47602 18.8595C5.00838 18.3971 4.63711 17.8465 4.38373 17.2396C4.13035 16.6328 3.99988 15.9817 3.99988 15.324C3.99988 14.6664 4.13035 14.0152 4.38373 13.4084C4.63711 12.8015 5.00838 12.2509 5.47602 11.7885L6.00002 11.3255"
        stroke="#354052"
        strokeWidth="2"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
};

export const reference_image = {
  faculty_member:
    "https://scholar.googleusercontent.com/citations?view_op=medium_photo&user=VRkiG1kAAAAJ&citpid=2",
  institution:
    "https://www.openmicroscopy.org/img/icons/user-groups_institutions.svg",
};
